export const splitNameAndSurname = (fullName: string) => {
  if (!fullName?.trim()) {
    // If fullName is empty or contains only spaces, return empty strings
    return { firstName: '', surname: '' };
  }

  const nameParts = fullName.trim().split(/\s+/); // Split by spaces
  const firstName = nameParts[0] ?? ''; // First part is the firstName
  const surname = nameParts.slice(1).join(' ') || ''; // Join the rest as surname, default to empty string

  return { firstName, surname };
};

export const getFullname = (
  firstName: string | undefined,
  surname: string | undefined
): string => {
  return `${firstName ?? ''} ${surname ?? ''}`.trim();
};

export function getFullnameInitials(fullName?: string) {
  if (!fullName) return '';

  const words = fullName.split(' ');
  const initials = words.map((word) => word.charAt(0).toUpperCase());

  return initials.join('');
}
